/*
 * Mercado Cosmetics — Smart Search configuration
 * ------------------------------------------------
 * This file is SAFE TO EDIT. It contains no logic, only vocabulary.
 * Add a line to SYNONYMS whenever a customer searches a word your
 * products do not literally contain.
 *
 * Format:  'what the customer types': 'what your catalogue calls it'
 * The value on the right MUST appear in your product titles, tags,
 * product types or vendor names, or the lookup will still fail.
 */
window.SmartSearchConfig = {
  searchFields: 'title,product_type,variants.title,vendor,tag',
  maxQueryLength: 64,
  SYNONYMS: {
    /* ---- Arabic (script) -> catalogue English ---- */
    'احمر شفاه': 'lipstick', 'روج': 'lipstick', 'ملمع شفاه': 'lip gloss', 'مرطب شفاه': 'lip balm',
    'زيت شفاه': 'lip oil', 'مسكارا': 'mascara', 'كونسيلر': 'concealer', 'خافي عيوب': 'concealer',
    'كريم اساس': 'foundation', 'فاونديشن': 'foundation', 'بودره': 'powder', 'بلاشر': 'blush',
    'احمر خدود': 'blush', 'هايلايتر': 'highlighter', 'برونزر': 'bronzer', 'كونتور': 'contour',
    'ايلاينر': 'eyeliner', 'محدد عيون': 'eyeliner', 'ظلال عيون': 'eyeshadow', 'ايشادو': 'eyeshadow',
    'فرشاه': 'brush', 'اسفنجه': 'sponge', 'مثبت مكياج': 'setting spray', 'مكياج': 'makeup',
    'سيروم': 'serum', 'مرطب': 'moisturizer', 'كريم مرطب': 'moisturizer', 'غسول': 'cleanser',
    'غسول وجه': 'cleanser', 'واقي شمس': 'sunscreen', 'واقي الشمس': 'sunscreen', 'حمايه من الشمس': 'sunscreen',
    'تونر': 'toner', 'ماسك': 'mask', 'قناع': 'mask', 'ماسك ورقي': 'sheet mask', 'شامبو': 'shampoo',
    'بلسم': 'conditioner', 'ماسك شعر': 'hair mask', 'زيت شعر': 'hair oil', 'عطر': 'perfume', 'عطور': 'perfume',
    'مزيل عرق': 'deodorant', 'صابون': 'soap', 'شفره حلاقه': 'razor', 'معقم': 'sanitizer',
    'عنايه بالبشره': 'skincare', 'عنايه بالشعر': 'hair care', 'اظافر': 'nails', 'مناكير': 'nails',

    /* ---- Transliterated Arabic (Latin letters) ---- */
    'ahmar shifah': 'lipstick', 'rouge': 'lipstick', 'maskara': 'mascara', 'kunsiler': 'concealer',
    'konsiler': 'concealer', 'boudra': 'powder', 'blasher': 'blush', 'aylayner': 'eyeliner',
    'shamboo': 'shampoo', 'balsam': 'conditioner', 'atr': 'perfume', 'ghasoul': 'cleanser',

    /* ---- Common misspellings ---- */
    'lipstic': 'lipstick', 'lipstik': 'lipstick', 'lip stick': 'lipstick', 'mascra': 'mascara',
    'mascare': 'mascara', 'maskera': 'mascara', 'concilor': 'concealer', 'consealer': 'concealer',
    'conciler': 'concealer', 'fondation': 'foundation', 'foundetion': 'foundation', 'higlighter': 'highlighter',
    'hilighter': 'highlighter', 'eyeshaddow': 'eyeshadow', 'eye shadow': 'eyeshadow', 'eye liner': 'eyeliner',
    'lipgloss': 'lip gloss', 'lipbalm': 'lip balm', 'moisturiser': 'moisturizer', 'mositurizer': 'moisturizer',
    'shampo': 'shampoo', 'shampoe': 'shampoo', 'conditoner': 'conditioner', 'perfum': 'perfume',
    'parfum': 'perfume', 'prefume': 'perfume',

    /* ---- Concept -> catalogue word (customers say it differently) ---- */
    'sunblock': 'sunscreen', 'sun block': 'sunscreen', 'sun cream': 'sunscreen', 'spf': 'sunscreen',
    'setting spray': 'sitting spray', 'fixer': 'sitting spray', 'makeup fixer': 'sitting spray',
    'makeup remover': 'micellar', 'micellar water': 'micellar', 'beauty blender': 'sponge', 'blender': 'sponge',
    'face wash': 'cleanser', 'facewash': 'cleanser', 'body lotion': 'body care', 'pimple': 'acne',
    'pimples': 'acne', 'dark spots': 'brightening', 'wrinkle': 'anti aging', 'anti-aging': 'anti aging',
    'dry skin': 'moisturizer', 'oily skin': 'cleanser', 'hair fall': 'hair', 'hair loss': 'hair', 'dandruff': 'shampoo',

    /* ---- Brand shorthand -> exact vendor spelling in your catalogue ---- */
    'elf': 'e.l.f', 'e l f': 'e.l.f', 'elf cosmetics': 'e.l.f', 'huda': 'hudabeauty', 'huda beauty': 'hudabeauty',
    'maybeline': 'maybelline', 'maybelin': 'maybelline', 'loreal': "l'oreal", 'l oreal': "l'oreal",
    'nyx cosmetics': 'nyx', 'abh': 'anastasia beverly hills', 'anastasia': 'anastasia beverly hills',
    'boj': 'beauty of joseon', 'joseon': 'beauty of joseon', 'ck': 'calvin klein',
    'bath and body': 'bath & body works', 'bbw': 'bath & body works', 'victoria secret': "victoria's secret"
  }
};